import { helpers } from 'vuelidate/lib/validators';

/**
 * All rcdin's must follow a certain pattern (One uppercase letter, followed by 10 digits)
 */
export const registeredConsumptionDeviceIdentificationNumber = helpers.regex(
    'registeredConsumptionDeviceIdentificationNumber',
    /^[A-Z]\d{10}$/,
);
